
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gTTqZSbvA5uq4asUiUVLLtzSO0i7N24TmFeRccmT_45etUMeta } from "/codebuild/output/src301800273/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indeximGgIIZlcPQmeJK8GIpQaxUqibJajLLrvtdzPOn1oV0Meta } from "/codebuild/output/src301800273/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchxNLdurocAq7BShqA8_45T8vxnv2eO_45Ti4os_FfqTAn_45MMMeta } from "/codebuild/output/src301800273/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as index96ehft6vfyBM_451fOHRXAlcGT5cDZGdxe5oYgTN_adHAMeta } from "/codebuild/output/src301800273/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93DoywsVEDeeEQmEVr3mwhmmglvPdoBT_lhnU033zdodMMeta } from "/codebuild/output/src301800273/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as index9NksZmtaMfW2TTVWWA2UW6u34Ttc6iTa6i_45qpcX0eJQMeta } from "/codebuild/output/src301800273/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93oUawJ5SL9602sxFoJWUY7hnM7h6fJnLksV7XwDAJxl4Meta } from "/codebuild/output/src301800273/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexSc7TPMffus1T21tT9ZoEUrvuHwitx87Mffxn_oCNe24Meta } from "/codebuild/output/src301800273/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93i8CU_H293a3orAMoHZ02Mjh_hOgiWX3oI__45B98PecnsMeta } from "/codebuild/output/src301800273/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexl3138A32stFHli19YStdh5lf7hrMhNPjmR3U1gYrdWEMeta } from "/codebuild/output/src301800273/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as index7cJ46VZui3NZVb70_86_45bydKfAwweFuDmy7k6DEEFD0Meta } from "/codebuild/output/src301800273/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src301800273/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src301800273/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src301800273/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src301800273/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src301800273/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: index9NksZmtaMfW2TTVWWA2UW6u34Ttc6iTa6i_45qpcX0eJQMeta || {},
    component: () => import("/codebuild/output/src301800273/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src301800273/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexSc7TPMffus1T21tT9ZoEUrvuHwitx87Mffxn_oCNe24Meta || {},
    component: () => import("/codebuild/output/src301800273/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src301800273/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexl3138A32stFHli19YStdh5lf7hrMhNPjmR3U1gYrdWEMeta || {},
    component: () => import("/codebuild/output/src301800273/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: index7cJ46VZui3NZVb70_86_45bydKfAwweFuDmy7k6DEEFD0Meta || {},
    component: () => import("/codebuild/output/src301800273/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]